var followService = require('followService'),
    contentService = require('contentService'),
    notification = require('notification'),
    loader = require('loader');

var follow = (function() {

    var $followBtnContainer = $('.follow-btns'),
        $followBtn = $('.follow-btns .btn'),
        $activeBtn = null;


    var btnClick = function() {
        $followBtn.on('click', function(e) {
            e.preventDefault();

            //This is to prevent firing the API off multiple times if people spam the button
            if (!$(this).hasClass('clicked-link')) {
                $('window').btnLoader($(this), {
                    dark: true,
                });

                $activeBtn = $(this).closest($followBtnContainer);

                var userID = $activeBtn.attr('data-user-id'),
                    loggedInUserID = $activeBtn.attr('data-logged-in-user-id');

                $(this).addClass('clicked-link');

                if ($(this).hasClass('following')) {
                    unfollowUserService(userID, unfollowUser);
                } else if ($(this).hasClass('follow')) {
                    followUserService(userID, followUser);
                }
            }
        });
    };


    var unfollowUser = function(response) {
        if (response.statusCode === 200) {
            toggleActiveBtn();

        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var followUser = function(response) {
        if (response.statusCode === 200) {
            toggleActiveBtn();

        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var toggleActiveBtn = function() {
        $('window').hideBtnLoader($('.clicked-link'));
        $('.clicked-link').removeClass('active clicked-link').siblings().addClass('active');
    };


    var getFollowData = function() {
        var followIDs = [];

        $followBtnContainer.each(function() {
            var userID = $(this).attr('data-user-id');
            followIDs.push(userID);
        });

        doIFollowService(followIDs, checkIfFollowing);
    };


    var checkIfFollowing = function(response) {
        if (response.statusCode === 200) {
            $.each(response.data, function(key, content) {
                var followingUserID = content.user_id,
                    $matchingUser = $('.follow-btns[data-user-id=' + followingUserID + ']');

                $matchingUser.parent().find('.placeholder').hide();

                if (content.doIFollow === 'mine') {
                    $matchingUser.parent().find('.edit-profile-btn').show();
                } else if (content.doIFollow === true) {
                    $matchingUser.find('.following').addClass('active');
                } else {
                    $matchingUser.find('.follow').addClass('active');
                }
            });
        }
    };


    var init = function() {
        if ($followBtnContainer.length) {
            btnClick();
            getFollowData();
        }
    };

    return {
        init: init
    };

})();

follow.init();



// WEBPACK FOOTER //
// ./library/js/modules/Follow.js